module.exports = __webpack_public_path__ + "img/visa.a3c3f9af.svg";